import * as React from "react";
import './index.scss';
import { editpen_White, save_White, close_White } from '../../../assets/images';
import { useTranslation } from 'react-i18next';
import { RESOURCE } from '../../../const/resource';
import { useSelector } from "react-redux";
import { selectors as imgSelector } from "../../../state/features/header";

export const MyCommandCell = (props: any) => {

  const { t } = useTranslation();

  const { dataItem } = props;
  const inEditField = dataItem[props.editField];
  const isNewGridItem = dataItem.Id === undefined;
  const { imgBaseUrlSelectors }: any = useSelector((state) => ({
    imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
  }));
  const imgPathUrl = imgBaseUrlSelectors;



  return inEditField ? (
    <td className="k-command-cell">
      <button
        className="editbtn mr-1" title={t(RESOURCE.MyK_Label_Save)}
        onClick={() =>
          isNewGridItem ? props.add(dataItem) : props.update(dataItem)
        }
      >
        <img src={imgPathUrl + save_White} alt={t(RESOURCE.MyK_Label_Save)} title={t(RESOURCE.MyK_Label_Save)} className="IconImg" />
      </button>
      <button
        className="editbtn" title={t(RESOURCE.MyK_Label_Cancel)}
        onClick={() =>
          isNewGridItem ? props.discard(dataItem) : props.cancel(dataItem)
        }
      >
        <img src={imgPathUrl + close_White} alt={t(RESOURCE.MyK_Label_Cancel)} title={t(RESOURCE.MyK_Label_Cancel)} className="IconImg" />
      </button>
    </td>
  ) : (
    <td className="k-command-cell">
      <button
        className="editbtn" title={props.dataItem?.description}
        onClick={() => props.edit(dataItem)}
      >
        <img src={imgPathUrl + editpen_White} alt={props.dataItem?.description} title={props.dataItem?.description} className="IconImg" />
      </button>
      {/* <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-remove-command"
        onClick={() =>
          confirm("Confirm deleting: " + dataItem.ProductName) &&
          props.remove(dataItem)
        }
      >
        Remove
      </button> */}
    </td>
  );
};
